import React, {Component} from 'react'
import * as config from '../Configuration/Config.js'
import {Redirect} from 'react-router-dom'
import qs from 'query-string';
import UserProfile from '../Configuration/UserProfile'
import Cookies from 'universal-cookie'
import moment from "moment"

// Function to clear complete cache data
const clearCacheData = () => {
    caches.keys().then((names) => {
      names.forEach((name) => {
        caches.delete(name);
      });
    });
    //alert('Complete Cache Cleared')
    };

class Imp extends Component {
    constructor() {
        super()

        this.state = {
          is_loaded: false,  
          redirect_login: false,
          redirect_home: false,
          imp: null
        }
    
    }   

    componentDidMount() {        
        var that = this;
        const params = qs.parse(this.props.location.search);
        const code = params.code;

        clearCacheData();    

        var c = new Cookies();
        c.remove('profile', { path: '/' });
                
        var c2 = new Cookies();
        c2.remove('email', { path: '/' });
      
        var c3 = new Cookies();
        c3.remove('authToken', { path: '/' });

        sessionStorage.clear();
        sessionStorage.removeItem('Username');
        sessionStorage.removeItem('atkn');
        sessionStorage.removeItem('homeurl');
        sessionStorage.removeItem('mmmenu');
        sessionStorage.removeItem('session_id');
        sessionStorage.removeItem('session_ipadress');

        if(typeof code === 'undefined')
        {
            console.log('code is undefined');
            that.setLogin();
        }
        else
        {
            console.log('code = ' +  code); 
            var today = moment().format('YYYYMMDD');

            var decodecode = Buffer.from(code,'base64').toString('ascii');
            console.log('decodecode = ' +  decodecode); 

            var cdate = decodecode.split("*")[0];
            var customer_id = decodecode.split("*")[1];

            console.log('cdate = ' +  cdate); 
            console.log('customer_id = ' +  customer_id); 

            if (cdate == today)
            {
                let uri = config.getAcumenAPIURL('api/token/imp/' + customer_id); 
                var myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/json");
                myHeaders.append("x-api-key", config.getAcumenAPIKey()); 
                myHeaders.append("table-prefix", "acumen_prod_");
                myHeaders.append("client_id",config.getCognitoClientId());
                myHeaders.append("pool_id",config.getCognitoPoolId());
                
                var that = this;
                var token = '';
                fetch(uri, {
                    method: 'get',
                    headers: myHeaders
                }).then(function(response) {
                    if (response.status >= 400) {
                    throw new Error("Bad response from server");              
                    }
                    //console.log(response,json());                              
                    return response.json();
                }).then(function(data) {    
                    console.log(data)  
                    that.setConfig(data);                
                });    
            }
            else
            {
                //date doesnt match
                that.setLogin();
            }
            
        }
    }

    setConfig(data)
    {
      var that = this;

      var c = new Cookies();
      c.remove('profile', { path: '/' });
              
      var c2 = new Cookies();
      c2.remove('email', { path: '/' });
    
      var c3 = new Cookies();
      c3.remove('authToken', { path: '/' });

      sessionStorage.clear();
      sessionStorage.removeItem('Username');
      sessionStorage.removeItem('atkn');
      sessionStorage.removeItem('homeurl');
      sessionStorage.removeItem('mmmenu');
      sessionStorage.removeItem('session_id');
      sessionStorage.removeItem('session_ipadress');

      var email = data.username;
      var token = data.access_token;
      var customer_id = data.customer_id;
      var user_id = data.user_id;

      config.EmailManager.setEmail(email);
      config.AuthManager.setToken(token);
            
      var p = new UserProfile();
      p.loadData(token,
          ()=>{
              that.setState({redirectToReferrer: true});
          }
      );
      
      that.setHome();      
    }

    setHome() 
    {
        this.setState({redirect_home: true, loaded: true});
    } 
  
    setLogin()
    {
        this.setState({redirect_login: true, loaded: true});
    }


    render() {
        if (this.state.loaded === false){
            return <div>Loading Customer Profile...</div>;
        }       

        if (this.state.redirect_login)
        {
            return <Redirect to='/login' />                  
        }
  
        if (this.state.redirect_home){
          return <div className="LogIn">
          Customer Profile Loaded <br />
          <button color="primary" name="save" className="loginButton btn btn-primary" onClick={event =>  window.location.href='/'}>
           Continue
          </button>
          </div>
        }
        else
        {
            return <div className="LogIn">
               Customer profile not found.               
               </div>
        }

        return <div className="LogIn">               
               </div>
    }
}

export default Imp


// WEBPACK FOOTER //
// ./src/Components/Imp/imp.js